module.exports = __webpack_public_path__ + "img/join_2.b003e29f.png";